import * as React from "react";
import { PrescriptionFormInputProvider } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormInputContext.js";
import { PrescriptionFormInputLabel } from "../../../../../PrescriptionFormInputLabel/steps/PrescriptionFormStep/components/PrescriptionFormInputLabel/PrescriptionFormInputLabel.js";
import { PrescriptionFormInputSelect } from "../../../../../PrescriptionFormInputSelect/steps/PrescriptionFormStep/components/PrescriptionFormInputSelect/PrescriptionFormInputSelect.js";
const PrescriptionFormInput = React.memo((props) => {
  const { side, hideLabels } = props;
  return /* @__PURE__ */ React.createElement(PrescriptionFormInputProvider, { ...props }, /* @__PURE__ */ React.createElement(PrescriptionFormInputLabel, { side, isHiddenVisually: hideLabels }), /* @__PURE__ */ React.createElement(PrescriptionFormInputSelect, null));
});
export {
  PrescriptionFormInput
};
//# sourceMappingURL=PrescriptionFormInput.js.map
